module.exports = __webpack_public_path__ + "img/1-sm.87618a92.jpg";